module.exports = __webpack_public_path__ + "media/images/views/home/step/step-4-f7dc20bd1aa2fded3814021c053a39a1.png";